module.exports = __webpack_public_path__ + "img/buddy_ears-04.7cabccc1.svg";